export default {
	guides       : [],
	courses      : [],
	totalGuides  : 0,
	totalCourses : 0,
}
